import { useState, useEffect, useRef } from "react";
import { BsHouseDoor, BsPerson, FaBars } from "../../../assets/icons/vander";
import { useAuthStore } from "../../../auth/hooks";
import { useSidebarStore } from "../../hooks";
import { Link } from "react-router-dom";

export const TopHeader = ({ Nav }) => {
  const {
    // Methods
    invertToggle,
  } = useSidebarStore();

  const { user, startLogout } = useAuthStore();
  const { firstName, lastName } = user;

  const dropdownRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="header-bar-doctor d-flex justify-content-between align-items-center">
      <div className="d-flex align-items-center">
        <button
          onClick={() => invertToggle()}
          className="btn btn-icon btn-pills btn-soft-primary me-2 show-small"
        >
          <FaBars />
        </button>
        <Nav />
      </div>

      <div className="dropdown dropdown-info" ref={dropdownRef}>
        <button
          type="button"
          className="btn btn-info text-dark show-big"
          onClick={() => setShowDropdown(!showDropdown)}
        >
          <BsPerson className="icon me-2" />
          Dr. {firstName} {lastName}
        </button>
        <button
          type="button"
          className="btn btn-icon btn-pills btn-info text-dark show-small"
          onClick={() => setShowDropdown(!showDropdown)}
        >
          <BsPerson className="icon" />
        </button>
        <div
          className={`${
            showDropdown ? "show" : ""
          } dropdown-menu dd-menu dropdown-menu-end shadow border-0`}
          style={{ minWidth: "200px", position: "absolute", right: "0" }}
        >
          <Link className="dropdown-item" to={"/doctor/profile"}>
            Configuración
          </Link>
          <button
            className="dropdown-item"
            onClick={() => {
              startLogout();
            }}
          >
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  );
};
